/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_FailedInputs */

const en_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const fr_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échoué`)
};

const de_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

const it_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non riuscita`)
};

const ru_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не пройдена`)
};

const es_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallido`)
};

const zh_cn2_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

const ja_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗`)
};

const hi_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल`)
};

const pt_pt2_editor_filter_failed = /** @type {(inputs: Editor_Filter_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprovado`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Editor_Filter_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_failed = /** @type {((inputs?: Editor_Filter_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_failed(inputs)
	if (locale === "de") return de_editor_filter_failed(inputs)
	if (locale === "it") return it_editor_filter_failed(inputs)
	if (locale === "ru") return ru_editor_filter_failed(inputs)
	if (locale === "es") return es_editor_filter_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_failed(inputs)
	if (locale === "ja") return ja_editor_filter_failed(inputs)
	if (locale === "hi") return hi_editor_filter_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_failed(inputs)
	return en_editor_filter_failed(inputs)
});